import React from "react";
import { Bar, Cell, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface TotalDepositsData {
    date: string;
    "Total Deposit": number;
}

interface TotalDepositsChartProps {
    data: TotalDepositsData[];
    formatter: (value: number) => string;
}

const TotalDepositsChart: React.FC<TotalDepositsChartProps> = ({ data, formatter }) => {
    const transformedData = data.map((item) => ({
        name: item.date,
        value: Number(item["Total Deposit"]),
    }));

    // Colors for positive and negative values
    const colors = {
        positive: "#22c55e", // green-500
        negative: "#ef4444", // red-500
        trend: "#0f212c", // dark blue (blue-800) for trend line
    };

    return (
        <>
            <h3 className={"font-semibold mb-8"}>Total Deposits</h3>

            <div className="h-[400px]">
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart data={transformedData} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
                        <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
                        <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} tickFormatter={formatter} />
                        <Tooltip
                            formatter={(value: number | undefined, name: string | undefined) => [
                                value !== undefined ? formatter(value) : "",
                                name === "value" ? "Total Deposits" : "Trend",
                            ]}
                            contentStyle={{
                                backgroundColor: "white",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "8px",
                            }}
                            cursor={{ fill: "#f8fafc" }}
                        />
                        <Bar dataKey="value" barSize={40} radius={[4, 4, 0, 0]}>
                            {transformedData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.value >= 0 ? colors.positive : colors.negative} />
                            ))}
                        </Bar>
                        <Line type="monotone" dataKey="value" stroke={colors.trend} strokeWidth={2} dot={false} activeDot={{ r: 4, fill: colors.trend }} />
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </>
    );
};

export default TotalDepositsChart;
